import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import InputNumber from 'antd/lib/input-number';
import DatePicker from 'antd/lib/date-picker';
import { translate } from 'react-i18next';
import moment from 'moment';
import {
  gendersT,
  maritalStatusesT,
  educationT,
  socialStatusT,
  socialStatus,
} from '../../../../common/enums';
import { translation as sectorTranslation } from '../../../../common/enums/sector';
import { translation as obligationTypeTranslation } from '../../../../common/enums/obligationType';
import Table from 'antd/lib/table';
import accountRules from '../../../../common/rules/accountRules';
import rules from '../../../../common/rules/rules';
import { rcFieldDecoratorOptions, createRcBackspaceHandler } from '../../../../common/utils/rcMask';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 9,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 15,
    },
    sm: {
      span: 14,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 14,
      offset: 6,
    },
    sm: {
      span: 14,
      offset: 6,
    },
  },
};

class DebtorUserProfile extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    account: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired
  };

  state = {
    showEmployer: [
      socialStatus.EMPLOYED_INDEFINITE,
      socialStatus.EMPLOYED_DEFINITE,
      socialStatus.AGREEMENT_OTHER,
    ].includes(this.props.account.profileData.socialStatus),
    showCompanyName: [socialStatus.SELF_EMPLOYED, socialStatus.OWN_BUSINESS_INCOME].includes(this.props.account.profileData.socialStatus),
    additionalPhoneNumbers: this.props.account.phoneNumbers,
    additionalEmails: this.props.account.Emails,
  };

  handleSocialStatusChange = value => {
    this.setState({
      showEmployer: [
        socialStatus.EMPLOYED_INDEFINITE,
        socialStatus.EMPLOYED_DEFINITE,
        socialStatus.AGREEMENT_OTHER,
      ].includes(value),
      showCompanyName: [socialStatus.SELF_EMPLOYED, socialStatus.OWN_BUSINESS_INCOME].includes(value),
    });
  };

  addPhoneNumber(e) {
    this.setState({additionalPhoneNumbers: [...this.state.additionalPhoneNumbers, {
          number: '',
          active: false,
          prefered: false,
          notContact: false,
          anotherPerson: false,
          checked: false,
        }
      ]
    });
  }

  addEmails(e) {
    this.setState({additionalEmails: [...this.state.additionalEmails, {
          email: '',
          prefered: false,
          notContact: false,
          anotherPerson: false,
          undeliverable: false,
        }
      ]
    });
  }

  handleChange(e, index, field) {
    this.state.additionalPhoneNumbers[index][field] = e.target.checked || e.target.value;
    this.setState({additionalPhoneNumbers: this.state.additionalPhoneNumbers});
  }

  removePhoneNumber(e, index) {
    this.state.additionalPhoneNumbers.splice(index, 1);
    this.setState({additionalPhoneNumbers: this.state.additionalPhoneNumbers});
  }

  removeEmail(e, index) {
    this.state.additionalEmails.splice(index, 1);
    this.setState({additionalEmails: this.state.additionalEmails});
  }

  render() {
    const { account, isEditable, form, t } = this.props;
    const { getFieldDecorator } = form;
    const { showEmployer } = this.state;
    const profileData = account.profileData;

    return (
      <div>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Osobné údaje')}</h3>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Meno')}>
          <span>{account.nameFirst}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Priezvisko')}>
          <span>{account.nameLast}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rodné priezvisko')}>
          <span>{account.birthLastName}</span>
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Kontaktné údaje')}</h3>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Ulica a číslo')}>
          {!isEditable && <span>{profileData.address.street}</span>}
          {isEditable &&
            getFieldDecorator('address.street', {
              initialValue: profileData.address.street,
            })(<Input size="default" placeholder={t('Ulica a číslo')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Mesto')}>
          {!isEditable && <span>{profileData.address.city}</span>}
          {isEditable &&
            getFieldDecorator('address.city', {
              initialValue: profileData.address.city,
            })(<Input size="default" placeholder={t('Mesto')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('PSČ')}>
          {!isEditable && <span>{profileData.address.zip}</span>}
          {isEditable &&
            getFieldDecorator('address.zip', {
              rules: [...rules.required, ...accountRules.zip],
              initialValue: profileData.address.zip,
            })(<Input size="default" placeholder={t('PSČ')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Počet rokov bývania na adrese')}>
          {!isEditable && <span>{profileData.address && profileData.address.yearsAtAddress}</span>}
          {isEditable &&
            getFieldDecorator('address.yearsAtAddress', {
              initialValue: profileData.address && profileData.address.yearsAtAddress,
            })(<InputNumber min={0} max={99} precision={0} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('E-mail')}>
          <span>{account.email != "" ? account.email : profileData.email}</span>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Telefónne číslo')}>
          {!isEditable && <span style={{ display: 'block'}}>{profileData.phone}</span>}
          {isEditable &&
            getFieldDecorator('phone', {
              rules: accountRules.telephoneNumber,
              initialValue: profileData.phone,
            })(<Input size="default" placeholder={t('T090x xxx xxx')} />)}
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Ostatné')}</h3>
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Pohlavie')}>
          {!isEditable && <span>{gendersT[profileData.gender]}</span>}
          {isEditable &&
            getFieldDecorator('gender', { initialValue: profileData.gender })(
              <Select size="default" placeholder={t('Vyberte pohlavie')}>
                {Object.entries(gendersT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rodné číslo')}>
          {!isEditable && <span>{profileData.personalNumber}</span>}
          {isEditable &&
            getFieldDecorator('personalNumber', {
              rules: accountRules.personalNumber,
              initialValue: profileData.personalNumber,
              ...rcFieldDecoratorOptions,
            })(<Input size="default" placeholder={t('rrmmddxxxx')} onKeyDown={createRcBackspaceHandler(form, 'personalNumber')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Číslo OP')}>
          {!isEditable && <span>{profileData.idCardNumber}</span>}
          {isEditable &&
            getFieldDecorator('idCardNumber', {
              rules: accountRules.idCardNumber,
              initialValue: profileData.idCardNumber,
            })(<Input size="default" placeholder={t('Číslo OP')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('IBAN')}>
          {!isEditable && <span>{profileData.iban}</span>}
          {isEditable &&
            getFieldDecorator('iban', {
              rules: accountRules.iban,
              initialValue: profileData.iban,
            })(<Input size="default" placeholder={t('IBAN')} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Rodinný stav')}>
          {!isEditable && <span>{maritalStatusesT[profileData.maritalStatus]}</span>}
          {isEditable &&
            getFieldDecorator('maritalStatus', {
              initialValue: profileData.maritalStatus,
            })(
              <Select size="default" placeholder={t('Vyberte rodinný stav')}>
                {Object.entries(maritalStatusesT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Počet detí')}>
          {!isEditable && <span>{profileData.kids}</span>}
          {isEditable &&
            getFieldDecorator('kids', { initialValue: profileData.kids })(
              <Input size="default" placeholder={t('Počet detí')} />
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Vzdelanie')}>
          {!isEditable && <span>{educationT[profileData.education]}</span>}
          {isEditable &&
            getFieldDecorator('education', {
              initialValue: profileData.education,
            })(
              <Select size="default" placeholder={t('Vyberte vzdelanie')}>
                {Object.entries(educationT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Zdroj príjmu')}>
          {!isEditable && <span>{socialStatusT[profileData.socialStatus]}</span>}
          {isEditable &&
            getFieldDecorator('socialStatus', {
              initialValue: profileData.socialStatus,
            })(
              <Select
                size="default"
                placeholder={t('Zdroj príjmu')}
                onChange={this.handleSocialStatusChange}
              >
                {Object.entries(socialStatusT).map(([key, value]) => (
                  <Option key={key} value={key}>
                    {value}
                  </Option>
                ))}
              </Select>
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Príjem od')}>
          {isEditable ? (
            getFieldDecorator('incomeFrom', {
              initialValue: profileData.incomeFrom ? moment(profileData.incomeFrom) : null,
            })(<DatePicker format="DD.MM.YYYY" />)
          ) : (
            <span>{profileData.incomeFrom ? moment(profileData.incomeFrom).format('DD.MM.YYYY') : ''}</span>
          )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Odvetvie')}>
          {isEditable ? (
            getFieldDecorator('sector', {
              initialValue: profileData.sector,
            })(
              <Select allowClear>
                {Object.entries(sectorTranslation).map(([key, label]) => (
                  <Select.Option key={key} value={Number(key)}>{label}</Select.Option>
                ))}
              </Select>
            )
          ) : (
            <span>{profileData.sector ? sectorTranslation[profileData.sector] : ''}</span>
          )}
        </Form.Item>

        {(this.state.showEmployer || this.state.showCompanyName) && (
          <Form.Item {...formItemLayout} label={t(this.state.showCompanyName ? 'Názov spoločnosti' : 'Názov zamestnávateľa')}>
            {!isEditable && <span>{profileData.employer}</span>}
            {isEditable &&
              getFieldDecorator('employer', {
                initialValue: profileData.employer,
                rules: [{ required: true, message: t('Povinné pole') }],
              })(<Input size="default" placeholder={t(this.state.showCompanyName ? 'Názov spoločnosti' : 'Názov zamestnávateľa')} />)}
          </Form.Item>
        )}

        <Form.Item {...tailFormItemLayout}>
          <h3>{t('Záväzky')}</h3>
        </Form.Item>

        {account.Loans && account.Loans.flatMap(l => l.Obligations || []).length > 0 && (
          <Table
            dataSource={account.Loans.flatMap(l => (l.Obligations || []).map(o => ({...o, loanNumber: l.loanNumber})))}
            columns={[
              { title: t('Typ záväzku'), dataIndex: 'type', render: v => obligationTypeTranslation[v] || v },
              { title: t('Pôvodná výška v EUR'), dataIndex: 'originalAmount' },
              { title: t('Mesačná splátka v EUR'), dataIndex: 'monthlyPayment', render: v => v != null ? v : '-' },
              { title: t('Kto poskytol'), dataIndex: 'provider' },
            ]}
            pagination={false}
            size="small"
            rowKey="id"
          />
        )}

        <Form.Item {...formItemLayout} label={t('Dlh na poistnom alebo daniach v EUR')}>
          {isEditable ? (
            getFieldDecorator('insuranceTaxDebt', {
              initialValue: profileData.insuranceTaxDebt,
            })(<InputNumber min={0} precision={0} />)
          ) : (
            <span>{profileData.insuranceTaxDebt}</span>
          )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Priemerný mesačný príjem (čistý)')}>
          {!isEditable && <span>{profileData.income.monthlyAvg} €</span>}
          {isEditable &&
            getFieldDecorator('income.monthlyAvg', {
              initialValue: profileData.income.monthlyAvg,
            })(
              <Input
                size="default"
                placeholder={t('Priemerný mesačný príjem (čistý)')}
                addonAfter="€"
              />
            )}
        </Form.Item>

        <Form.Item {...formItemLayout} label={t('Približné mesačné náklady')}>
          {!isEditable && <span>{profileData.costs ? profileData.costs.monthlyAvg : 0} €</span>}
          {isEditable &&
            getFieldDecorator('costs.monthlyAvg', {
              initialValue: profileData.costs ? profileData.costs.monthlyAvg : 0,
            })(
              <Input size="default" placeholder={t('Približné mesačné náklady')} addonAfter="€" />
            )}
        </Form.Item>
        
      </div>
    );
  }
}

export default translate()(DebtorUserProfile);



// WEBPACK FOOTER //
// ./src/features/account-management/components/profile/DebtorUserProfile.js